module.exports = __webpack_public_path__ + "media/assets/images/flags/lt-0725bd781a1437ae33cea2eca87acaf9.svg";